<template>
  <div class="item-box-430">
    <div class="org-head">
      <div class="box-title-430">服务详情</div>
      <Button class="back-btn" type="primary" @click="back">返回上一步</Button>
    </div>
    <div class="org-title">
      <div class="box-title-430">{{ baseInfo.name }}</div>
      <Button v-if="userInfo.userType === 5" class="org-status">{{
        coInfo.coSts | orgStatusCh
      }}</Button>
    </div>
    <div class="org-edu">
      <div
        v-for="(item, index) in educationList"
        :key="index"
        class="org-edu-box"
      >
        <div class="edu-box-left">
          <div class="edu-name">
            {{ item.educationBureauName }}
          </div>
          <div class="edu-operator">
            {{ item.reviewName }}
            <span v-if="item.reviewState == 2">
              <i>(</i><i>驳回</i><i>)</i>
            </span>
          </div>
          <div v-if="item.reviewState == 0">审批中</div>
          <div v-if="item.reviewState == 2">原因：{{ item.remark }}</div>
          <div v-if="item.reviewTime != 0" class="edu-pass-time">
            <span v-if="item.reviewState == 1">通过时间：</span>
            {{ item.reviewTime }}
          </div>
        </div>
        <Button class="org-pass-status">{{
          item.reviewState | eduStatus
        }}</Button>
      </div>
    </div>
    <div class="info-box">
      <div class="info-top">
        <div
          v-for="(item, index) in tabInfo"
          :key="index"
          class="info-top-item"
          :class="item.active == active ? 'info-top-item-active' : ''"
          @click="changeActive(item.active)"
        >
          {{ item.name }}
        </div>
        <!-- <div v-if="!merchantInfo.businessAddr" class="info-top-tip">
            <Icon type="ios-alert" color="#488ffa"></Icon>
            <span>“商户信息”未完善，无法创建课班、托管及订餐！</span>
          </div> -->
      </div>
      <div v-show="active == 1" class="info-content">
        <OrgBaseInfo
          ref="orgbase"
          :sys-org-school-details="schoolList"
          :org-education-bureau-details="educationList"
          :org-name="orgName"
          :base-info="baseInfo"
          :co-info="coInfo"
          :dtl-info="dtlInfo"
          :show-modify-btn="true"
          @modifyOrgName="modifyOrgName"
        ></OrgBaseInfo>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import operationAdmin from '@/request/operationAdmin/index.js';
import OrgBaseInfo from '../assets/components/OrgBaseInfo.vue';
export default {
  components: {
    OrgBaseInfo
  },
  filters: {
    // 机构状态
    orgStatusCh(sts) {
      if (sts === 1) {
        return '运营中';
      }
      return '已停止服务';
    },
    // 教育局状态
    eduStatus(status) {
      let str = '';
      switch (Number(status)) {
        case 1:
          str = '已通过';
          break;
        case 0:
          str = '审核中';
          break;
        case 2:
          str = '审核未通过';
          break;
        default:
          break;
      }
      return str;
    }
  },
  data() {
    return {
      orgId: '', // 机构id
      tabInfo: [
        {
          name: '服务信息',
          active: 1
        }
        // {
        //   name: '商户信息',
        //   active: 2
        // }
      ],
      active: 2,
      merchantInfo: {}, // 商户信息
      baseInfo: {}, // 教育局基本信息
      coInfo: {}, // 合作信息
      dtlInfo: {}, // 详细信息
      schoolList: [], // 学校列表
      educationList: [], // 教育局列表
      orgName: '' // 机构名称
    };
  },
  computed: { ...mapState(['userInfo']) },
  created() {
    this.orgId = this.$route.query.orgId ? this.$route.query.orgId : '';
    this.$route.query.active ? (this.active = this.$route.query.active) : '';
    this.getOrgDetails();
    // this.getMerchantInfo();
    this.getOrgEdus();
    this.getOrgSchools();
  },
  methods: {
    // 返回上一步
    back() {
      this.$router.go(-1);
    },
    // 点击切换选中的
    changeActive(active) {
      this.active = active;
    },
    refreshForm() {
      this.getMerchantInfo();
    },
    // 获取机构详情页面
    async getOrgDetails() {
      const params = {
        orgId: this.orgId
      };
      const res = await operationAdmin.getOrgDetailsNew(params);
      if (res.status === 200) {
        console.log(res, '获取机构详情');
        this.baseInfo = res.message.baseInfo;
        this.coInfo = res.message.coInfo;
        this.dtlInfo = res.message.dtlInfo;
        this.orgName = this.baseInfo.name;
      }
    },
    // 获取机构的商户信息
    // async getMerchantInfo() {
    //   const params = {
    //     orgId: this.orgId
    //   };
    //   const res = await operationAdmin.getOrgMerchantInfoNew(params);
    //   console.log(res.message, '服务详情获取的信息1111-------');
    //   if (res.status === 200) {
    //     this.merchantInfo = res.message ? res.message : {};
    //   }
    // },
    // 获取机构的教育局
    async getOrgEdus() {
      const params = {
        orgId: this.orgId
      };
      const res = await operationAdmin.getOrgEdusNew(params);
      if (res.status === 200) {
        this.educationList = res.message;
        this.educationList.forEach(item => {
          item.reviewName = item.reviewName === null ? '' : item.reviewName;
          switch (item.reviewState) {
            case 0:
              item.reviewStateTxt = '审核中';
              item.reviewTime = '';
              item.StepsCurrent = 1;
              break;
            case 1:
              item.reviewStateTxt = '已通过';
              item.StepsCurrent = 4;
              break;
            case 2:
              item.reviewStateTxt = '审核未通过';
              item.StepsCurrent = 1;
              break;
            default:
              item.reviewStateTxt = '';
              item.reviewTime = '';
              item.StepsCurrent = 0;
              break;
          }
        });
      }
    },
    // 获取机构学校统计数据
    async getOrgSchools() {
      const params = {
        orgId: this.orgId
      };
      const res = await operationAdmin.getOrgSchoolsNew(params);
      if (res.status === 200) {
        this.schoolList = res.message;
      }
    },
    // 修改名称
    async modifyOrgName(name) {
      const params = {
        orgId: this.orgId,
        name
      };
      const res = await operationAdmin.updateOrgName(params);
      if (res.status === 200) {
        this.orgName = name;
        this.$refs.orgbase.updatedOrgName();
      }
    }

  }
};
</script>
<style lang="scss" scoped>
.item-box-430 {
  padding: 16px;
}
.org-head {
  display: flex;
  align-items: center;
  // justify-content: space-between;
  padding-bottom: 16px;
  border-bottom: 1px solid #ccc;
  .back-btn {
    margin-left: auto;
  }
}
.org-title {
  display: flex;
  align-items: center;
  padding-top: 16px;
  .org-status {
    margin-left: 32px;
  }
}
.org-edu {
  display: inline-block;
  margin-top: 32px;
  display: flex;
  .org-edu-box {
    width: 400px;
    display: flex;
    padding: 16px;
    background: #f5f7f9;
    border-radius: 4px;
    justify-content: space-between;
    .edu-name {
      font-weight: 600;
      font-size: 16px;
      color: #222;
    }
    .edu-operator {
      line-height: 30px;
    }
    .edu-pass-time {
      line-height: 30px;
      color: #989898;
    }
  }
  .org-edu-box + .org-edu-box {
    margin-left: 16px;
  }
}
.info-box {
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #e5e5e5;
  margin-top: 32px;
  .info-top {
    height: 50px;
    background: #f5f7f9;
    padding: 0 20px;
    display: flex;
    align-items: center;
    .info-top-item {
      position: relative;
      line-height: 20px;
      font-size: 14px;
      font-weight: 600;
      color: #666;
      border-bottom: 1px solid transparent;
    }
    .info-top-item-active {
      color: #488ffa;
      border-bottom: 1px solid #488ffa;
    }
    .info-top-item + .info-top-item {
      margin-left: 32px;
    }
    .info-top-tip {
      margin-left: 16px;
      color: #488ffa;
    }
  }
  .info-content {
    padding: 16px;
  }
}
</style>
